export default {
  getCountryList: (state) => {
    if (state.items.countries && state.favouriteGroup) {
      return [...state.favouriteGroup, ...state.items.countries];
    } else {
      return [];
    }
  },
};
